import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';

const Project_tab_History: React.FC<ProjectProps> = ({ projectId, refreshDataCounter }) => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [projectId, refreshDataCounter]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemChangeLogs/ByProject/' + projectId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    const changelogColinfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'When', dataProp: 'createdOn', dataType: 'datetime', sort: 'desc' },
        { title: 'Who', dataProp: 'createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'What', dataProp: 'remark', filterInfo: { filterType: 'Textbox' } },
        { title: 'ItemNr', dataProp: 'item.itemNr', filterInfo: { filterType: 'CheckboxList' } },
    ];

    return (
        <>
            <DataTable
                name='dtProjectChangeLog'
                colInfos={changelogColinfos}
                tableData={data}
            />

        </>
    );
}
export default Project_tab_History;